import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useTheme } from '../context/ThemeContext';
import { CheckCircle, Download, ArrowLeft } from 'lucide-react';

const CheckoutSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const { clearCart } = useCart();
  const { currentTheme } = useTheme();
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Clear the cart on successful payment
    clearCart();

    if (sessionId) {
      fetch(`/api/payments/checkout/status/${sessionId}`)
        .then(res => res.json())
        .then(data => {
          setOrderDetails(data);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [sessionId, clearCart]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="w-20 h-20 rounded-full mx-auto flex items-center justify-center" 
             style={{ backgroundColor: `${currentTheme.primary}20` }}>
          <CheckCircle className="w-10 h-10" style={{ color: currentTheme.primary }} />
        </div>
        
        <h1 className="text-4xl font-bold text-white">Payment Successful!</h1>
        <p className="text-gray-400 text-lg">
          Thank you for your purchase. Your beats are ready.
        </p>

        {orderDetails && orderDetails.items && (
          <div className="bg-white/5 rounded-xl p-6 text-left space-y-3">
            <h3 className="text-white font-bold">Order Summary</h3>
            {orderDetails.items.map((item, i) => (
              <div key={i} className="flex justify-between text-sm">
                <span className="text-gray-300">{item.name} × {item.quantity}</span>
                <span className="text-white">${(item.price * item.quantity).toFixed(2)}</span>
              </div>
            ))}
            <div className="border-t border-white/10 pt-2 flex justify-between font-bold">
              <span className="text-white">Total</span>
              <span style={{ color: currentTheme.primary }}>${orderDetails.amount?.toFixed(2)}</span>
            </div>
          </div>
        )}

        <div className="space-y-3 pt-4">
          <Link
            to="/beats"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-bold text-black transition-transform hover:scale-105"
            style={{ backgroundColor: currentTheme.primary }}
          >
            <ArrowLeft className="w-4 h-4" />
            Browse More Beats
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccess;
